import styled from 'styled-components';

// Self-hosted (public/assets/flags) rather than react-flagkit, which loads from
// cdn.jsdelivr.net: blocked by our CSP img-src, and a third-party IP leak.
// Covers every FlagKit country plus the few Shopify lists that FlagKit lacks.
const FLAGS_PATH = '/assets/flags';

const CountryFlag = ({ code }: { code: string }) => (
  <Flag
    src={`${FLAGS_PATH}/${code}.svg`}
    alt=""
    width={24}
    height={24}
    loading="lazy"
    // A country Shopify adds later with no SVG yet shows its name without a broken image.
    onError={(e) => (e.currentTarget.style.visibility = 'hidden')}
  />
);

export default CountryFlag;

const Flag = styled.img`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.flagBorder};
  object-fit: cover;
`;
